import Maintenance from './index';

export default { path: '/home/maintenance', component: Maintenance };
